import http from "services/http";
import { GetNewArrivalsParamsType } from "types/params";

const PRE_ENDPOINT = "/api/method/freshdi.api.web.v3.listing";

export const apiGetListingFilters = (url: string) =>
  http.get(`${PRE_ENDPOINT}.get_filters`, { params: { url } });

export const apiGetNewArrivals = (data?: GetNewArrivalsParamsType) => {
  return http.get(`${PRE_ENDPOINT}.get_items_by_cate`, {
    params: { ...data, category_class: "new-product" },
  });
};

export const apiGetFreshdiChoice = (data?: GetNewArrivalsParamsType) =>
  http.get(`${PRE_ENDPOINT}.get_items_by_cate`, {
    params: { ...data, category_class: "hot-price-product" },
  });
